import {Injectable, Type} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {PlaceApiModel} from '../../../../../api/models/place.api-model';
import {PlaceCheckInApiModel} from '../../../../../api/models/place-check-in.api-model';
import {PlaceRestService} from '../../../../../api/services/place.rest.service';
import {SocialListAdapter, SocialListLoadResult} from '../social-list-adapter.interface';
import {SocialListModalConfig} from '../social-list-modal-config.interface';
import {SocialListType} from '../social-list-type.type';
import {PlaceCheckInListItemComponent} from '../items/place-check-in-list-item.component';

@Injectable({providedIn: 'root'})
export class PlaceCheckInsSocialListAdapter implements SocialListAdapter<PlaceApiModel, never, PlaceCheckInApiModel> {
  public readonly type: SocialListType = 'place-check-ins';
  public readonly itemComponent: Type<PlaceCheckInListItemComponent> = PlaceCheckInListItemComponent;
  public readonly emptyTranslationKey = 'places.check_in.visitors_empty';
  public readonly trimmedTranslationKey = '';
  public readonly titleTranslationKey = 'places.check_in.visitors_title';

  constructor(private readonly placeApi: PlaceRestService) {
  }

  public loadPage(
    config: SocialListModalConfig<PlaceApiModel>,
    page: number,
    pageSize: number,
  ): Observable<SocialListLoadResult<PlaceCheckInApiModel>> {
    return this.placeApi.getCheckIns(config.subject, page, pageSize).pipe(
      map(result => ({
        items: result.records || [],
        hasMore: !!result.view?.['hydra:next'],
      })),
      catchError(() => of({items: [], hasMore: false})),
    );
  }

  public mergeItems(existingItems: PlaceCheckInApiModel[], incomingItems: PlaceCheckInApiModel[]): PlaceCheckInApiModel[] {
    return [...existingItems, ...incomingItems.filter(incoming => !existingItems.some(existing => existing.id === incoming.id))];
  }

  public trackBy(index: number, item: PlaceCheckInApiModel): string {
    return item?.id?.toString() || `${index}`;
  }
}
